(function($) {


  //Product Gallery
	if ($('.product-imageslide .swiper-slide').length > 1) {
      
    document.querySelectorAll('.gallery-top:not(.gallery-top--game, .gallery-top--vip)').forEach((item) => {
      
      const sliderThumbs = new Swiper(item.nextElementSibling.firstElementChild, { 
        direction: item.dataset.direction, 
        slidesPerView: 6,
        spaceBetween: 10,
        freeMode: true, 
        //noSwiping: false,
        breakpoints: { 
          0: { 
            direction: 'horizontal',  
            slidesPerView: 4,
          },
          425: { 
            direction: 'horizontal',  
            slidesPerView: 5,
          },
          769: { 
            direction: item.dataset.direction,  
            slidesPerView: 5,
          },
        }
      });
      const sliderImages = new Swiper(item, { 
        direction: item.dataset.direction, 
        slidesPerView: 1, 
        //loop:false,
        spaceBetween: 0, 
        /* 1000ms was a full SECOND per image. Swiper ignores wheel input while a
           transition runs, so the gallery held you for ~13s before the page could
           move — measured 10 Aug: at 1000ms the page never took over at all; at
           250ms it releases in a few seconds. This is the single biggest reason
           the gallery felt broken. Applies to the main image slider only — the
           thumbnail strip is untouched. */
        speed: 250,
        //draggable: false, 
        /* Wheel-browsing is KEPT, but throttled. Astrid, 10 Aug: "I can't seem to
           fully scroll an image, it forces me down or up" / "it doesn't let me stay
           on the image I want". She is describing a TWITCHY control, not asking for
           the feature to go away — the stock config fired a slide change on every
           wheel tick, so the lightest trackpad touch threw her off the image she was
           looking at. (An earlier pass set `mousewheel:false`, which removed the
           feature she was asking us to improve. Reverted 10 Aug.)
             thresholdDelta 40 — ignore incidental/light scrolls, so she can rest on
                                 an image without it jumping.
             thresholdTime 300 — at most one image per 300ms, so a fast scroll can
                                 still get past the gallery instead of trapping you.
             releaseOnEdges    — at the first/last image the page takes over, so the
                                 gallery can never hold you hostage.
             forceToAxis       — only a scroll along the gallery's own axis counts. */
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          thresholdDelta: 40,
          thresholdTime: 300,
        },
        //allowTouchMove: false,
        grabCursor: true,
        //watchOverflow: true,
        /* Astrid: a video kept playing after you moved to another image, and
           there was no way to "exit" it. pauseAllMedia() already knows how to
           stop a Vimeo/YouTube iframe (postMessage) and a native <video> — it
           was just never called on slide change. */
        on: {
          slideChange: function () {
            if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
            /* AGNTC 2026-08-10: pausing was not enough. The player stayed in the
               DOM, so the slide you left was still a video when you came back to
               it, and its iframe went on eating drag gestures. Unload restores
               the product photo. `this` is the Swiper instance; this.el scopes
               it to THIS gallery. */
            if (typeof window.unloadAllMedia === 'function') window.unloadAllMedia(this.el);
          },
        },
        thumbs: {
          swiper: sliderThumbs
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        scrollbar: {
          el: '.swiper-scrollbar'
        },
        breakpoints: { 
          0: { 
            direction: 'horizontal',  
            mousewheel: false,

          },
          769: { 
            direction: item.dataset.direction,
          },
        }
      });

    })
    document.querySelectorAll('.gallery-top--game').forEach((item) => {
      
      const sliderThumbs = new Swiper(item.nextElementSibling.firstElementChild, { 
        direction: item.dataset.direction, 
        slidesPerView: 6,
        spaceBetween: 15,
        freeMode: true, 
        //noSwiping: false,
        breakpoints: { 
          0: { 
            direction: 'horizontal',  
            slidesPerView: 4,
          },
          425: { 
            direction: 'horizontal',  
            slidesPerView: 5,
          },
          769: { 
            direction: item.dataset.direction,  
            slidesPerView: 5,
          },
        }
      });
      const sliderImages = new Swiper(item, { 
        direction: item.dataset.direction, 
        slidesPerView: 1, 
        //loop:false,
        spaceBetween: 0, 
        /* 1000ms was a full SECOND per image. Swiper ignores wheel input while a
           transition runs, so the gallery held you for ~13s before the page could
           move — measured 10 Aug: at 1000ms the page never took over at all; at
           250ms it releases in a few seconds. This is the single biggest reason
           the gallery felt broken. Applies to the main image slider only — the
           thumbnail strip is untouched. */
        speed: 250,
        //draggable: false, 
        /* Wheel-browsing is KEPT, but throttled. Astrid, 10 Aug: "I can't seem to
           fully scroll an image, it forces me down or up" / "it doesn't let me stay
           on the image I want". She is describing a TWITCHY control, not asking for
           the feature to go away — the stock config fired a slide change on every
           wheel tick, so the lightest trackpad touch threw her off the image she was
           looking at. (An earlier pass set `mousewheel:false`, which removed the
           feature she was asking us to improve. Reverted 10 Aug.)
             thresholdDelta 40 — ignore incidental/light scrolls, so she can rest on
                                 an image without it jumping.
             thresholdTime 300 — at most one image per 300ms, so a fast scroll can
                                 still get past the gallery instead of trapping you.
             releaseOnEdges    — at the first/last image the page takes over, so the
                                 gallery can never hold you hostage.
             forceToAxis       — only a scroll along the gallery's own axis counts. */
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          thresholdDelta: 40,
          thresholdTime: 300,
        },
        // allowTouchMove: false,
        grabCursor: true,
        //watchOverflow: true,
        /* Astrid: a video kept playing after you moved to another image, and
           there was no way to "exit" it. pauseAllMedia() already knows how to
           stop a Vimeo/YouTube iframe (postMessage) and a native <video> — it
           was just never called on slide change. */
        on: {
          slideChange: function () {
            if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
            /* AGNTC 2026-08-10: pausing was not enough. The player stayed in the
               DOM, so the slide you left was still a video when you came back to
               it, and its iframe went on eating drag gestures. Unload restores
               the product photo. `this` is the Swiper instance; this.el scopes
               it to THIS gallery. */
            if (typeof window.unloadAllMedia === 'function') window.unloadAllMedia(this.el);
          },
        },
        thumbs: {
          swiper: sliderThumbs
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        scrollbar: {
          el: '.swiper-scrollbar'
        },
        breakpoints: { 
          0: { 
            direction: 'horizontal',  
            slidesPerView: 1.25,
         
          },
          767: { 
            slidesPerView: 1,
            spaceBetween: 0,
            direction: item.dataset.direction,
          },
        }
      });

    })
    document.querySelectorAll('.gallery-top--vip').forEach((item) => {
      
      const sliderThumbs = new Swiper(item.nextElementSibling.firstElementChild, { 
        direction: item.dataset.direction, 
        slidesPerView: 6,
        spaceBetween: 15,
        freeMode: true, 
        //noSwiping: false,
        breakpoints: { 
          0: { 
 
            slidesPerView: 4,
          },
          425: { 
            direction: 'horizontal',  
            slidesPerView: 5,
          },
          768: { 
            direction: item.dataset.direction,  
            slidesPerView: 5,
          },
        }
      });
      const sliderImages = new Swiper(item, { 
        direction: item.dataset.direction, 
        slidesPerView: 1, 
        //loop:false,
        spaceBetween: 0, 
        /* 1000ms was a full SECOND per image. Swiper ignores wheel input while a
           transition runs, so the gallery held you for ~13s before the page could
           move — measured 10 Aug: at 1000ms the page never took over at all; at
           250ms it releases in a few seconds. This is the single biggest reason
           the gallery felt broken. Applies to the main image slider only — the
           thumbnail strip is untouched. */
        speed: 250,
        //draggable: false, 
        /* Wheel-browsing is KEPT, but throttled. Astrid, 10 Aug: "I can't seem to
           fully scroll an image, it forces me down or up" / "it doesn't let me stay
           on the image I want". She is describing a TWITCHY control, not asking for
           the feature to go away — the stock config fired a slide change on every
           wheel tick, so the lightest trackpad touch threw her off the image she was
           looking at. (An earlier pass set `mousewheel:false`, which removed the
           feature she was asking us to improve. Reverted 10 Aug.)
             thresholdDelta 40 — ignore incidental/light scrolls, so she can rest on
                                 an image without it jumping.
             thresholdTime 300 — at most one image per 300ms, so a fast scroll can
                                 still get past the gallery instead of trapping you.
             releaseOnEdges    — at the first/last image the page takes over, so the
                                 gallery can never hold you hostage.
             forceToAxis       — only a scroll along the gallery's own axis counts. */
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          thresholdDelta: 40,
          thresholdTime: 300,
        },
        // allowTouchMove: false,
        grabCursor: true,
        //watchOverflow: true,
        /* Astrid: a video kept playing after you moved to another image, and
           there was no way to "exit" it. pauseAllMedia() already knows how to
           stop a Vimeo/YouTube iframe (postMessage) and a native <video> — it
           was just never called on slide change. */
        on: {
          slideChange: function () {
            if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
            /* AGNTC 2026-08-10: pausing was not enough. The player stayed in the
               DOM, so the slide you left was still a video when you came back to
               it, and its iframe went on eating drag gestures. Unload restores
               the product photo. `this` is the Swiper instance; this.el scopes
               it to THIS gallery. */
            if (typeof window.unloadAllMedia === 'function') window.unloadAllMedia(this.el);
          },
        },
        thumbs: {
          swiper: sliderThumbs
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        scrollbar: {
          el: '.swiper-scrollbar'
        },
        breakpoints: { 
          0: { 
            direction: 'horizontal',  
            slidesPerView: 1.12,
         
          },

          768.5: { 
            slidesPerView: 1,
            spaceBetween: 0,
            direction: item.dataset.direction,
          },
        }
      });

    })
       
    }
    
    //Product Accordion
    $('.product__accordion details').on('click', function(){
      // $(this).parent().siblings('.product__accordion').find('details').removeAttr('open');
    });
    //Size guid
    $('.js-guid-ajax').magnificPopup({
      type: 'ajax',
      showCloseBtn:true,
      closeOnBgClick: true,
      closeBtnInside: true,
      callbacks: {
        parseAjax: function(mfpResponse) {
          mfpResponse.data = jQuery(mfpResponse.data).find('#sizelist');
        },
        ajaxContentAdded: function(response) {

        }
      },
    });
    //Product gallery popup
    $('.zoom-gallery').magnificPopup({
      type: 'image',
			fixedContentPos: false,
			fixedBgPos: true,
			overflowY: 'auto',
			removalDelay: 300, //delay removal by X to allow out-animation
			callbacks: {
			beforeOpen: function() {
				  // just a hack that adds mfp-anim class to markup 
				   this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
				   this.st.mainClass = 'mfp-zoom-in customer-image custom-arrow';
				}
			  },
			closeBtnInside: true,
			preloader: false,
			
			midClick: true,
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0,1] 
			},
      buildControls: function() {
        // re-appends controls inside the main container
        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
      }
      
    });
    //how-apply-btn
    $('.js-how-apply-btn').magnificPopup({
      type: 'inline',
      preloader: false
    });
    //Product sticky button 
    $(window).on("scroll",function () {
      let bodyScroll = $(window).scrollTop(),
          navbar = $(".sticky-order-panel");

      if(bodyScroll > $('.buy_btn-form').offset().top+30){
        navbar.addClass("product_appear");
      }else{
        navbar.removeClass("product_appear");
      }
    });
    if($(window).width() < 768){
      setTimeout(function(){
        
        $('.product-fixed-submit .add-to-cart-button[value]').text('Pre-order')
     
      },1500)

    } 

 
})(jQuery); //jQuery




//Accompanying goods
    //change selector (option-grid-Size)
   /* if(document.querySelectorAll('.option-grid.option-grid-Size label').length > 0){
      document.querySelectorAll('.option-grid.option-grid-Size label').forEach((item)=>{
        
          if(item.querySelector('input').checked === true){
              acceTabs(item.dataset.name)
          }
        
          item.addEventListener('click', function(){
              acceTabs(item.dataset.name)
          });
      })
    }
    function acceTabs(element){
        if(document.querySelectorAll('.accompanying-goods-wrap').length > 0){
          document.querySelectorAll('.accompanying-goods-wrap').forEach((tab)=>{
              tab.classList.remove('show');
          })
        }
        if(document.querySelectorAll(`.accompanying-goods-wrap[data-vairiant="${element}"]`).length > 0){
            document.querySelector(`.accompanying-goods-wrap[data-vairiant="${element}"]`).classList.add('show');
        }
      
    }*/
    if(document.querySelectorAll('.accompanying-good-form').length > 0){
        document.querySelectorAll('.accompanying-good-form .product-form__submit').forEach((addTocart)=>{
          addTocart.addEventListener('click', function(){
            this.classList.add('added')
            if(addTocart.classList.contains('added')){
              setTimeout(function(){
                addTocart.classList.remove('added')
              }, 5000)
            }
          });

        })
        $('.js-complementary-variant-label').on('click', function(){
          if(!$(this).hasClass('active')){
            $(this).addClass('active')
          }else{
            $(this).removeClass('active')
          }
        })
        $('.variant-item-input').on('change', function(){
          $(this).parents('.complementary-products-variants').children('.complementary-products-variant-label').removeClass('active')
        })
    }
    
    function addThreeDaysToToday() {
      var today = new Date();
      today.setDate(today.getDate() + 3); 
    
      var monthNames = [
        "January", "February", "March", "April", "May", "June", "July",
        "August", "September", "October", "November", "December"
      ];
    
      var month = monthNames[today.getMonth()];
      var day = today.getDate(); 

      var formattedDate = month + " " + day;
      
      return formattedDate;
    }
    function addFiveDaysToToday() {
      var today = new Date();
      today.setDate(today.getDate() + 5); 
    
      var monthNames = [
        "January", "February", "March", "April", "May", "June", "July",
        "August", "September", "October", "November", "December"
      ];
    
      var month = monthNames[today.getMonth()];
      var day = today.getDate(); 

      var formattedDate = month + " " + day;
      
      return formattedDate;
    }

    var futureDate3 = addThreeDaysToToday();
    var futureDate5 = addFiveDaysToToday();
    if(document.querySelectorAll('.product-game-delivery__date3').length > 0){
      document.querySelector('.product-game-delivery__date3').innerHTML = futureDate3
    }
     if(document.querySelectorAll('.product-game-delivery__date5').length > 0){
      document.querySelector('.product-game-delivery__date5').innerHTML = futureDate5
    }  
    




/*************Loading button add to cart after load page********************/
document.addEventListener('DOMContentLoaded', function() {
  
  if(document.querySelector('#add-to-cart').disabled != true){
    
      document.querySelector('#add-to-cart').disabled = true
      setTimeout(function(){
        document.querySelector('#add-to-cart').disabled = false
      },5000)
    
  }

});


 function sticky_label_click(option,section,position,forloop) {
   jQuery('.option-grid-'+option+' .customradio').removeClass('active');
   jQuery('.footer-label-'+section+'-'+position+'-'+forloop+'').addClass('active');
   jQuery('#'+section+'-'+position+'-'+forloop+'').click();
 }

(function($) {
 $('.stiky-btn-add').click(function (e) {
  // $('#add-to-cart').click(); 
  }); 

   $(".cstm").on("click", function(e) {
     e.stopPropagation();
    let types=$(this).attr('data-type');
    let for_i=$(this).attr('for'); 
    $('.option-grid-footer-'+types+' label').removeClass('active');
    $(this).addClass('active');
    let for_main  = for_i.replace("footer-", "label-");
     let for_main_i  = for_i.replace("footer-", "");
     console.log(for_main_i);
     $('.option-grid-main-'+types+' label').removeClass('active');
     $('.'+for_main).addClass('active');
     $('.option-grid-main-'+types+' .'+for_main+' input').prop('checked', true);
  //   $('.option-grid-main-'+types+' #'+for_main).click(); 
     
  }) 

$("#add-to-cart").on("change", function() { 
  console.log('change')
})
   
  /*
  $("#curentvariant").on("change", function() { 
  $('.curentvariant-fixed').val($(this).val()); 
})
  $(".curentvariant-fixed").on("change", function() {
  $('#curentvariant').val($(this).val()); 
})
  */
  
})(jQuery); 